export default __webpack_public_path__ + "static/7-551931438ba0bbc55027d0255ac4464f.jpg";